/**
 * List of all Contentful Locale codes used by Snap. Not all locales are used by every MWP website,
 * this is the superset of all utilized Locale Codes.
 *
 * NOTE: this differs from the Locales type defined in `.src/extractPageText/types.ts` (effectively
 * just a string type) as this is an enum with defined values that can be referenced when defining
 * magic strings or defining relationship maps.
 */
export enum ContentfulLocaleCode {
  Arabic = 'ar',
  Bengali_Bangladesh = 'bn-BD',
  Bengali_India = 'bn-IN',
  Bulgarian_Bulgaria = 'bg-BG',
  Chinese_Simplified = 'zh-Hans',
  Chinese_Traditional = 'zh-Hant',
  Croatian_Croatia = 'hr-HR',
  Czech_Czech_Republic = 'cs-CZ',
  Danish_Denmark = 'da-DK',
  Dutch_Netherlands = 'nl-NL',
  English_United_Kingdom = 'en-GB',
  English_United_States = 'en-US',
  Estonian_Estonia = 'et-EE',
  Filipino_Philippines = 'fil-PH',
  Finnish_Finland = 'fi-FI',
  French_France = 'fr-FR',
  German_Germany = 'de-DE',
  Greek_Greece = 'el-GR',
  Gujarati_India = 'gu-IN',
  Hindi_India = 'hi-IN',
  Hungarian_Hungary = 'hu-HU',
  Indonesian_Indonesia = 'id-ID',
  Irish_Ireland = 'ga-IE',
  Italian_Italy = 'it-IT',
  Japanese_Japan = 'ja-JP',
  Kannada_India = 'kn-IN',
  Korean_South_Korea = 'ko-KR',
  Latvian_Latvia = 'lv-LV',
  Lithuanian_Lithuania = 'lt-LT',
  Malay_Malaysia = 'ms-MY',
  Malayalam_India = 'ml-IN',
  Maltese_Malta = 'mt-MT',
  Marathi_India = 'mr-IN',
  Norwegian_Bokmal_Norway = 'nb-NO',
  Polish_Poland = 'pl-PL',
  Portuguese_Brazil = 'pt-BR',
  Portuguese_Portugal = 'pt-PT',
  Punjabi = 'pa',
  Romanian_Romania = 'ro-RO',
  Russian_Russia = 'ru-RU',
  Slovak_Slovakia = 'sk-SK',
  Slovenian_Slovenia = 'sl-SI',
  Spanish = 'es',
  Spanish_Argentina = 'es-AR',
  Spanish_Mexico = 'es-MX',
  Spanish_Spain = 'es-ES',
  Swedish_Sweden = 'sv-SE',
  Tamil_India = 'ta-IN',
  Telugu_India = 'te-IN',
  Thai_Thailand = 'th-TH',
  Turkish_Turkey = 'tr-TR',
  Ukrainian_Ukraine = 'uk-UA',
  Urdu_Pakistan = 'ur-PK',
  Vietnamese_Vietnam = 'vi-VN',
}
